import React from "react";
import {
  ImageTwentyFour,
  ImageTwentyOne,
  ImageTwentyThree,
  ImageTwentyTwo,
  PhoneImage,
} from "../assets/images";

const EightTab = () => {
  return (
    <div className="eightTab">
      {/* Top Section */}
      <div className="eightTabHeader">
        <h1 className="headerTitle">
          Physical Rehabilitation & Fatigue Management
        </h1>
        <p className="headerDescription">
          Smart, adaptive recovery support—from yoga to sleep routines—designed
          for daily resilience.
        </p>
      </div>

      {/* Main Content */}
      <div className="eightTabMain">
        {/* Left Side (Phone Image) */}
        <div className="eightTabLeft">
          <img src={PhoneImage} alt="Mobile App" className="phoneImg" />
        </div>

        {/* Right Side (Features List) */}
        <div className="eightTabRight">
          <div className="featureItem">
            <img src={ImageTwentyThree} alt="Yoga" className="featureIcon" />
            <p className="featureText">Personalized yoga sessions</p>
          </div>
          <div className="featureItem">
            <img src={ImageTwentyTwo} alt="Mobility" className="featureIcon" />
            <p className="featureText">
              Lymphedema prevention & guided mobility
            </p>
          </div>
          <div className="featureItem">
            <img src={ImageTwentyOne} alt="Tracking" className="featureIcon" />
            <p className="featureText">
              Pain tracking, posture correction & recovery monitoring
            </p>
          </div>
          <div className="featureItem">
            <img src={ImageTwentyFour} alt="Sleep" className="featureIcon" />
            <p className="featureText">
              Sleep hygiene, hydration nudges & activity tracking
            </p>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <div className="eightTabFooter">
        <p className="footerText">
          Every movement matters—small steps lead to lasting recovery.
        </p>

        <button className="footerButton">Start Your Daily Recovery Plan</button>
      </div>

      {/* ✅ CSS inside component */}
      <style>{`
        .eightTab {
          width: 100%;
          padding: 60px 40px;
          box-sizing: border-box;
          font-family: Arial, sans-serif;
          text-align: center;
        }

        .eightTabHeader {
          margin-bottom: 50px;
        }

        .headerTitle {
          font-size: 36px;
          font-weight: bold;
          margin-bottom: 20px;
          color: #222;
          line-height: 1.3;
        }

        .headerDescription {
          font-size: 18px;
          color: #555;
          max-width: 750px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .eightTabMain {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 40px;
          margin-bottom: 50px;
          flex-wrap: wrap;
        }

        .eightTabLeft {
          flex: 0 0 380px;
          display: flex;
          justify-content: center;
        }

        .phoneImg {
          width: 100%;
          max-width: 380px;
          height: auto;
        }

        .eightTabRight {
          flex: 0 0 400px;
          display: flex;
          flex-direction: column;
          gap: 40px;
          justify-content: center;
          text-align: left;
        }

        .featureItem {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .featureIcon {
          width: 70px;
          height: 70px;
          object-fit: contain;
        }

        .featureText {
          font-size: 18px;
          color: #333;
          margin: 0;
          line-height: 1.4;
        }

        .eightTabFooter {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 30px;
          padding: 2rem;
          flex-direction: column;
        }

        .footerText {
          background-color: #ffeef1;
          color: #1a1a1a;
          padding: 1rem 1.5rem;
          border-radius: 20px;
          font-size: 1.2rem;
          font-weight: 500;
          margin: 0;
          text-align: center;
        }

        .footerButton {
          background-color: #104d37;
          color: white;
          border: none;
          padding: 1rem 2rem;
          border-radius: 30px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        /* ✅ Responsive */
        @media (max-width: 1024px) {
          .headerTitle {
            font-size: 30px;
          }
          .headerDescription {
            font-size: 16px;
          }
          .featureText {
            font-size: 16px;
          }
        }

        @media (max-width: 768px) {
          .eightTabMain {
            flex-direction: column;
            gap: 40px;
          }
          .eightTabRight {
            text-align: center;
            align-items: center;
          }
          .featureItem {
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .headerTitle {
            font-size: 24px;
          }
          .headerDescription {
            font-size: 14px;
          }
          .featureIcon {
            width: 50px;
            height: 50px;
          }
          .featureText {
            font-size: 14px;
          }
          .footerText {
            font-size: 1rem;
          }
          .footerButton {
            font-size: 1rem;
            padding: 0.8rem 1.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default EightTab;
